import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

var Tag = /*#__PURE__*/function (_React$Component) {
  _inherits(Tag, _React$Component);

  var _super = _createSuper(Tag);

  function Tag() {
    var _this;

    _classCallCheck(this, Tag);

    _this = _super.apply(this, arguments);
    _this.state = {
      show: true
    };

    _this.TagClassName = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          isBadge = _this$props.isBadge,
          reverse = _this$props.reverse;
      var show = _this.state.show;
      return classNames("roo-tag roo-tag-".concat(type), {
        'roo-badge': isBadge,
        'roo-tag-reverse': isBadge ? false : reverse
      }, reverse ? "roo-badge-reverse roo-badge-".concat(type) : '', {
        hidden: !show
      });
    };

    _this.handleClick = function (event) {
      var _this$props2 = _this.props,
          closeable = _this$props2.closeable,
          onClose = _this$props2.onClose; // setState 之后作为回调参数，所以需要缓存

      event.persist();

      if (closeable) {
        _this.setState({
          show: false
        }, function () {
          if (onClose) {
            onClose(event);
          }
        });
      }
    };

    return _this;
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          closeable = _a.closeable,
          style = _a.style,
          className = _a.className,
          type = _a.type,
          isBadge = _a.isBadge,
          reverse = _a.reverse,
          onClose = _a.onClose,
          onClick = _a.onClick,
          restProps = __rest(_a, ["children", "closeable", "style", "className", "type", "isBadge", "reverse", "onClose", "onClick"]);

      var stl = onClick ? _Object$assign({
        cursor: 'pointer'
      }, style) : style;
      return /*#__PURE__*/React.createElement("span", _Object$assign({}, restProps, {
        onClick: onClick,
        style: stl || {},
        className: classNames(this.TagClassName(), className || '')
      }), children, /*#__PURE__*/React.createElement("i", {
        className: classNames('roo-icon roo-icon-times-circle', {
          hidden: !closeable
        }),
        onClick: this.handleClick
      }));
    }
  }]);

  return Tag;
}(React.Component);

Tag.defaultProps = {
  isBadge: false,
  reverse: false,
  type: 'primary',
  closeable: false,
  onClose: function onClose() {},
  onClick: null
};
Tag.propTypes = {
  isBadge: PropTypes.bool,
  reverse: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'success', 'info', 'warning', 'danger']),
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func
};
export default Tag;